import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { IMasterStatus } from "../../../redux/status/status.types";
import { IStoreState } from "../../../redux/initialStoreState";
import { LoadState } from "../../../constants/enums";
import { getLowestOngoingStatus } from "../helpers/leadHelpers";

export const useDefaultOngoingStatus = () => {
  const [defaultOngoingStatus, setDefaultOngoingStatus] =
    useState<IMasterStatus | null>(null);

  const { list: driveStatusList, loading: driveStatusLoading } = useSelector(
    (storeState: IStoreState) => storeState.leads.driveStatusList,
  );

  useEffect(() => {
    if (
      driveStatusLoading !== LoadState.Loaded ||
      driveStatusList.length === 0
    ) {
      return;
    }

    const ongoingStatus = getLowestOngoingStatus(driveStatusList);

    if (ongoingStatus) {
      setDefaultOngoingStatus({
        ...ongoingStatus,
        drive_status_uuid:
          ongoingStatus.drive_status_uuid || ongoingStatus.status_uuid,
      });
    }
  }, [driveStatusLoading, driveStatusList]);

  return defaultOngoingStatus;
};
